export const VocabAuth = {
  greetings: ["Excelente vamos a empezar.", "Great let us begin."],
  pre_submit_instructions: [
    "Ayudanos completando la siguiente informacion:",
    "Help us filling out the following fields:",
  ],
  email: ["Correo electronico", "email"],
  password: ["Contraseña", "Password"],
  username: ["Nombre usuario", "Username"],
  name: ["Nombre", "Name"],
  lastname_1: ["Apellido 1", "Lastname 1"],
  lastname_2: ["Apellido 2", "Lastname 2"],

  submit_button: ["Registrame", "Register"],
  submit_tooltip: [
    "Nos encantará tenerte a bordo :)",
    "We'd love have you on board :)",
  ],

  post_submit_greetings: ["Ya casi!", "Almost there"],
  post_submit_instructions: [
    "Te enviaremos un correo de confirmacion, por favor revisa tu banjeda (y el folder de spam por si acaso)",
    "Great! We'll send you a confirmation email. Please check your inbox (and spam folder, just in case).",
  ],

  login: ["Iniciar sesion", "Login"],
  login_failed: [
    "Error al iniciar sesión. Por favor, revise sus credenciales.",
    "Login failed. Please check your credentials.",
  ],
  no_account: ["¿No tienes una cuenta?", "Dont have an account?"],
  register: ["Registrarse", "Register"],

  login_patient_label: ["Paciente", "Patient"],
  login_professional_label: ["Profesional", "Pro"],
};

export type VocabAuthKey = keyof typeof VocabAuth;
export default VocabAuth;
